import AddNew from "assets/icons/add_new.svg?react";
import CloseIcon from "assets/icons/close.svg?react";
import MinusNew from "assets/icons/minus_new.svg?react";
import Search from "assets/icons/search.svg?react";
import Print from "assets/icons/print.svg?react";
import Reverse from "assets/icons/reverse.svg?react";
import EditIcon from "assets/icons/edite.svg?react";
import AnnotationsIcon from "assets/icons/comment.svg?react";
import DownloadIcon from "assets/icons/download.svg?react";
import DossierIcon from "assets/icons/folder_dossier_added.svg?react";
import CaseIcon from "assets/icons/attachToCase2.svg?react";
import RegistryIcon from "assets/icons/listIcon.svg?react";
import SignatureIcon from "assets/icons/signature.svg?react";
import { useContext, useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import {
  faCaretLeft,
  faCaretRight,
  faAnglesLeft,
  faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";
import NewIcon from "assets/icons/new_tab.svg?react";
import { FC, Props, Option } from "./typings";
import useGetPDFViewer from "hooks/useGetPDFViewer";
import HollowButton from "components/HollowButton";
import Button from "components/Button";
import fileService from "api/fileService";
import PackagesContext from "contexts/PackagesContext";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CertContext from "contexts/CertContext";
import { Tooltip } from "@mui/material";
import Dropdown from "components/OptionsCard/Dropdown";
import Popper from "components/Popper";
import Input from "components/Input";
import DossierFilesContext from "contexts/DossierFilesContext";
import { useTranslation } from "react-i18next";

const PDFVieverHeader: FC<Props> = ({
  file,
  onlyPDFButtons = false,
  title,
  headerClassName,
  withoutBorder,
  setShowComments,
  onCloseButton,
  pages,
  currentPage,
  onGotoNextPage,
  onGotoPrevPage,
  inModal,
  handleOpenInNewTab,
  handleDownload,
  handleAddCase,
  handleAddDossier,
  handleAddToRegistry,
  showCloseButton = true,
  searchString,
  setSearchString,
  matches,
  currentMatchIndex,
  nextMatch,
  prevMatch,
  sign = false,
  showSignButton = false,
  onSign,
  onGotoFirstPage,
  onGotoLastPage,
}) => {
  const { t } = useTranslation();
  function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(
      () => window.matchMedia(query).matches,
    );

    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }, [query]);

    return matches;
  }

  const isMobile = useMediaQuery("(max-width: 767px)");

  const navigate = useNavigate();
  const {
    PDF,
    setPDF,
    setRotate,
    getRotate,
    getDrawLine,
    getDrawPin,
    setDrawLine,
    setDrawPin,
    setDrawHighlight,
    getDrawHighlight,
  } = useGetPDFViewer();

  const { mutate: updateName } = fileService.useUpdateAttachment();
  const { packages, setPackages } = useContext(PackagesContext);
  const { dossierFiles, setDossierFiles } = useContext(DossierFilesContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const PDFId = queryParams.get("pdf");
  const { setCert } = useContext(CertContext);

  const splittedPDFId = PDFId?.split(":") ?? [];

  const packId = splittedPDFId.length >= 0 ? splittedPDFId[0] : null;
  const fileUri = splittedPDFId.length >= 2 ? splittedPDFId[2] : null;

  const [anotationsOptions, setAnnotationsOptions] = useState<Option[]>([]);

  const [showAnnotationsOptions, setShowAnnotationsOptions] =
    useState<boolean>(false);
  const refWrapper = useRef();

  const [searchOptions, setShowSearchOptions] = useState<boolean>(false);
  const searchRef = useRef();

  const [showRegistryOptions, setShowRegistryOptions] = useState<boolean>(false);
  const registryRef = useRef();

  useEffect(() => {
    const opt = [
      {
        name: t("pdfViewer.annotationsList"),
        callback: () => {
          setShowComments();
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("pdf.highlightAnnotation"),
        callback: () => {
          setDrawLine(!getDrawLine());
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("pdfViewer.pointAnnotation"),
        callback: () => {
          setDrawPin(!getDrawPin());
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
      {
        name: t("pdfViewer.selectionAnnotation"),
        callback: () => {
          setDrawHighlight(!getDrawHighlight());
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      },
    ];

    setAnnotationsOptions(opt);
  }, [showAnnotationsOptions]);

  const handleRotate = (opositeSite: boolean) => {
    const rotate = getRotate();
    if (opositeSite) {
      if (rotate + 90 > 360) {
        setRotate(90);
        return;
      }
      setRotate(rotate + 90);
      return;
    }

    if (rotate - 90 < 0) {
      setRotate(270);
      return;
    }

    setRotate(rotate - 90);
  };

  const handleChangeZoom = (value: number) =>
    setPDF({ ...PDF, zoom: value as number });

  const printPDF = async () => {
    if (file instanceof Blob) {
      const pdfFile = new File([file], "wydruk.pdf", {
        type: "application/pdf",
      });
      const blobUrl = URL.createObjectURL(pdfFile);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.src = blobUrl;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };

      iframe.onafterprint = () => {
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(iframe);
      };
    }

    // if (file instanceof Blob) {
    //   const pdf = await getDocument(await file.arrayBuffer()).promise;

    //   const printWindow = window.open("", "", "width=600,height=600");
    //   printWindow!.document.open();

    //   for (let i = 1; i <= pdf.numPages; i++) {
    //     const page = await pdf.getPage(i);
    //     const viewport = page.getViewport({ scale: 1 });

    //     const canvas = document.createElement("canvas");
    //     const context = canvas.getContext("2d");
    //     printWindow.document.appendChild(canvas);

    //     canvas.width = viewport.width;
    //     canvas.height = viewport.height;

    //     await page.render({ canvasContext: context, viewport }).promise;
    //   }
    //   printWindow!.document.close();
    //   printWindow!.focus();

    //   printWindow!.print();
    // }

    // //@ts-ignore
    // html2canvas(pdfRef.current).then((canvas) => {
    //   const printWindow = window.open("", "", "width=600,height=600");
    //   printWindow!.document.open();
    //   printWindow!.append(canvas);
    //   printWindow!.document.close();
    //   printWindow!.focus();document
    //   printWindow!.print();
    //   // setTimeout(() => {
    // });
  };

  const handleClose = () => {
    setCert(null);
    if (onCloseButton) {
      onCloseButton();
    } else {
      const url = new URL(window.location.href); // Pobierz obecny URL
      url.searchParams.delete("pdf"); // Usuń parametr 'pdf'

      // Zaktualizuj URL bez przeładowania strony, zachowując inne parametry
      navigate(`${url.pathname}${url.search}`);
    }
  };

  const [isEditingTitle, setIsEditingTitle] = useState<boolean>(false);
  const changeNameInputRef = useRef();
  const [newName, setNewName] = useState<string>(title ?? "");

  const handleShowEdit = () => {
    setIsEditingTitle(true);
  };

  const commitNewTitle = (title: string) => {
    const newPackages = [...packages];
    const newFiles = [...dossierFiles];
    const pack = newPackages.find((p) => {
      if (!p?.Attachments) return null;
      return p.Attachments.find((a) => a.Uri === fileUri);
    });

    const file = newFiles.find((p) => p.FileUri === fileUri || p.Id === packId);

    if (pack) {
      const attach = pack.Attachments.find((a) => a.Uri === fileUri);
      attach.Label = title;
      setPackages(newPackages);

      setNewName(title);
      updateName(
        {
          AttachmentId: attach.Id,
          Label: title,
          OwnerId: pack.Id,
          OwnerKind: pack.Kind,
        },
        {
          onSuccess: () => setIsEditingTitle(false),
        },
      );
    }

    if (file) {
      file.Label = title;
      setDossierFiles(newFiles);

      setNewName(title);
      updateName(
        {
          AttachmentId: undefined,
          Label: title,
          OwnerId: file.Id,
          OwnerKind: file.Kind,
        },
        {
          onSuccess: () => setIsEditingTitle(false),
        },
      );
    }
  };

  // Ikona „Dodaj do rejestru" (Umowy / Faktury i rachunki). Wydzielona, bo używana
  // zarówno w trybie zwykłym, jak i modalnym (np. podgląd pliku w PreviewModal).
  const renderRegistryButton = () =>
    handleAddToRegistry ? (
      <>
        <Tooltip title="Dodaj do rejestru">
          <div
            ref={registryRef}
            onClick={() => setShowRegistryOptions(!showRegistryOptions)}
            className={classNames(
              styles.button,
              inModal ? styles.modalButton : null,
              showRegistryOptions ? styles.active : null,
            )}
          >
            <RegistryIcon />
          </div>
        </Tooltip>
        <Popper
          anchorEl={registryRef?.current}
          open={showRegistryOptions}
          setOpen={setShowRegistryOptions}
        >
          <div className={styles.registryDropdown}>
            <div
              className={styles.registryOption}
              onClick={() => {
                setShowRegistryOptions(false);
                handleAddToRegistry("contracts");
              }}
            >
              Rejestr umów
            </div>
            <div
              className={styles.registryOption}
              onClick={() => {
                setShowRegistryOptions(false);
                handleAddToRegistry("invoices");
              }}
            >
              Rejestr faktur i rachunków
            </div>
          </div>
        </Popper>
      </>
    ) : null;

  return (
    <div
      className={`${styles.header} ${headerClassName} ${
        withoutBorder && styles.withoutBorder
      } ${inModal && styles.inModal}`}
    >
      <div className={styles.leftWrapper}>
        <div className={styles.title}>
          {/* {showTitle && (item?.Dossier?.Label ?? pack.S1)} */}
          {!isEditingTitle && (
            <div className={styles.titleLeft}>
              <div className={styles.titleWrapper}>
                {newName ?? ""}
                {!inModal && (
                  <div
                    className={classNames(styles.button, styles.editName)}
                    title={t("tooltips.renameFile")}
                    onClick={handleShowEdit}
                  >
                    <EditIcon />
                  </div>
                )}
              </div>
            </div>
          )}
          {isEditingTitle && (
            <div className={styles.inlineEditor}>
              <input
                ref={changeNameInputRef}
                autoFocus={true}
                className={styles.newFolderInput}
                key="input_newFolderrr"
                defaultValue={newName ?? ""}
                onBlur={(e) => commitNewTitle(e.target.value)}
                onFocus={(e) => {
                  e.currentTarget.setSelectionRange(0, 0);
                }}
                placeholder={t("dossier.newFolder")}
                id="input_newFolder"
                onKeyDownCapture={(e) => {
                  if (e.key === "Enter") {
                    const i = e.target as HTMLInputElement;
                    commitNewTitle(i.value);
                  } else if (e.key === "Escape") {
                    setIsEditingTitle(false);
                  }
                  e.stopPropagation();
                }}
                onClickCapture={(e) => e.stopPropagation()}
              ></input>

              <HollowButton
                className={styles.smallButton}
                text={t("common.cancel")}
                onClick={() => {
                  setIsEditingTitle(false);
                }}
              ></HollowButton>
              <Button
                text={t("common.save")}
                onClick={() =>
                  commitNewTitle(
                    (changeNameInputRef.current as HTMLInputElement).value,
                  )
                }
                className={styles.smallButton}
              ></Button>
            </div>
          )}
        </div>
      </div>
      {!isEditingTitle && (
        <div className={styles.rightWrapper}>
          <div
            className={classNames(
              styles.pages,
              sign ? styles.large : undefined,
            )}
          >
            {sign && (
              <HollowButton
                className={styles.pageButton2}
                text="<<"
                element={
                  <FontAwesomeIcon icon={faAnglesLeft}></FontAwesomeIcon>
                }
                onClick={onGotoFirstPage}
              ></HollowButton>
            )}
            <HollowButton
              className={styles.pageButton}
              text="<"
              element={<FontAwesomeIcon icon={faCaretLeft}></FontAwesomeIcon>}
              onClick={onGotoPrevPage}
            ></HollowButton>
            <div className={styles.number}>
              {currentPage}/{pages}
            </div>
            <HollowButton
              className={styles.pageButton}
              text=">"
              onClick={onGotoNextPage}
              element={<FontAwesomeIcon icon={faCaretRight}></FontAwesomeIcon>}
            ></HollowButton>
            {sign && (
              <HollowButton
                className={styles.pageButton2}
                text=">>"
                onClick={onGotoLastPage}
                element={
                  <FontAwesomeIcon icon={faAnglesRight}></FontAwesomeIcon>
                }
              ></HollowButton>
            )}
          </div>

          <Tooltip title={t("common.rotate")}>
            <div
              onClick={() => handleRotate(true)}
              className={classNames(
                styles.button,
                inModal ? styles.modalButton : null,
              )}
            >
              <Reverse />
            </div>
          </Tooltip>
          <Tooltip title={t("pdfViewer.zoomOut")}>
            <div
              onClick={() => handleChangeZoom(PDF.zoom - 0.15)}
              className={classNames(
                styles.button,
                inModal ? styles.modalButton : null,
              )}
            >
              <MinusNew />
            </div>
          </Tooltip>

          <Tooltip title={t("common.zoomIn")}>
            <div
              onClick={() => handleChangeZoom(PDF.zoom + 0.15)}
              className={classNames(
                styles.button,
                inModal ? styles.modalButton : null,
              )}
            >
              <AddNew />
            </div>
          </Tooltip>

          {!isMobile && (
            <>
              <div className={styles.spacer}></div>

              <Tooltip title={t("common.search")}>
                <div
                  ref={searchRef}
                  onClick={() => setShowSearchOptions(!searchOptions)}
                  className={classNames(
                    styles.button,
                    inModal ? styles.modalButton : null,
                  )}
                >
                  <Search />
                </div>
              </Tooltip>

              <Popper
                anchorEl={searchRef?.current}
                open={searchOptions}
                setOpen={setShowSearchOptions}
              >
                <div className={styles.dropdown}>
                  <Input
                    label={t("pdfViewer.searchPhrase")}
                    value={searchString}
                    onChange={(val) => setSearchString(val)}
                  ></Input>
                  {searchString && (
                    <div className={styles.searchResults}>
                      {t("pdfViewer.foundCount", { count: matches?.length })}
                      <HollowButton
                        text="<"
                        onClick={prevMatch}
                        disabled={currentMatchIndex == 0}
                      ></HollowButton>
                      {currentMatchIndex + 1}/{matches?.length}
                      <HollowButton text=">" onClick={nextMatch}></HollowButton>
                    </div>
                  )}
                </div>
              </Popper>

              {!onlyPDFButtons && !inModal && !sign && (
                <>
                  {/* {handleEdit &&
                (Number(fileKind) === ItemKind.CaseFile ||
                  Number(fileKind) === ItemKind.EditorDocument) && (
                  <div
                    title="Edytuj"
                    onClick={handleEdit}
                    className={styles.button}
                  >
                    <EditIcon
                      style={{
                        width: "16px",
                        height: "16px",
                      }}
                      title="Edytuj"
                    />
                  </div>
                )} */}

                  {/* {(Number(fileKind) === ItemKind.CaseFile ||
                Number(fileKind) === ItemKind.EditorDocument) && (
                <div
                  title="Podpisz elektronicznie"
                  onClick={handleSign}
                  className={styles.button}
                >
                  <SignIcon
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                    title="Podpisz elektronicznie"
                  />
                </div>
              )} */}

                  {showSignButton && (
                    <Tooltip title="Podpisz elektronicznie">
                      <div
                        onClick={() => onSign?.()}
                        className={classNames(
                          styles.button,
                          inModal ? styles.modalButton : null,
                        )}
                      >
                        <SignatureIcon
                          style={{ width: "16px", height: "16px" }}
                        />
                      </div>
                    </Tooltip>
                  )}

                  <Tooltip title={t("pdfViewer.print")}>
                    <div
                      onClick={printPDF}
                      className={classNames(
                        styles.button,
                        inModal ? styles.modalButton : null,
                      )}
                    >
                      <Print />
                    </div>
                  </Tooltip>

                  {handleDownload && (
                    <div
                      title={t("common.download")}
                      onClick={handleDownload}
                      className={styles.button}
                    >
                      <DownloadIcon title={t("common.download")} />
                    </div>
                  )}

                  {handleAddCase && (
                    <div
                      title={t("tooltips.linkToCase")}
                      onClick={handleAddCase}
                      className={styles.button}
                    >
                      <CaseIcon title={t("tooltips.linkToCase")} />
                    </div>
                  )}

                  {handleAddDossier && (
                    <div
                      title={t("chat.addToDossier")}
                      onClick={handleAddDossier}
                      className={styles.button}
                    >
                      <DossierIcon title={t("chat.addToDossier")} />
                    </div>
                  )}

                  {renderRegistryButton()}
                </>
              )}

              {!inModal && (
                <Tooltip title={t("pdfViewer.annotations")}>
                  <div
                    onClick={() => {
                      setShowAnnotationsOptions(!showAnnotationsOptions);
                    }}
                    className={`${styles.button} ${
                      getDrawLine() || getDrawPin() || getDrawHighlight()
                        ? styles.active
                        : ""
                    }`}
                    ref={refWrapper}
                  >
                    <AnnotationsIcon />
                  </div>
                </Tooltip>
              )}

              {showAnnotationsOptions && (
                <Dropdown
                  toggle={() => setShowAnnotationsOptions(false)}
                  options={anotationsOptions}
                  refWrapper={refWrapper}
                  rightSide={true}
                  showOptions={showAnnotationsOptions}
                  selectedElements={[]}
                  setSelectedElements={() => {}}
                  scrollWrapper={null}
                />
              )}

              {inModal && handleDownload && (
                <div
                  title={t("common.download")}
                  onClick={handleDownload}
                  className={styles.button}
                >
                  <DownloadIcon title={t("common.download")} />
                </div>
              )}

              {!onlyPDFButtons && !inModal && (
                <Tooltip title={t("tooltips.openInNewWindow")}>
                  <div
                    onClick={async () => {
                      window.open(
                        `${
                          import.meta.env.VITE_APP_SITE ??
                          "https://alfa.pocztaprawnicza.pl"
                        }/document?pdf=${PDFId}`,
                      );
                    }}
                    className={styles.button}
                  >
                    <NewIcon />
                  </div>
                </Tooltip>
              )}

              {inModal && (
                <Tooltip title={t("tooltips.openInNewWindow")}>
                  <div
                    onClick={async () => {
                      if (handleOpenInNewTab) {
                        handleOpenInNewTab();
                      } else {
                        window.open(
                          `${
                            import.meta.env.VITE_APP_SITE ??
                            "https://alfa.pocztaprawnicza.pl"
                          }/document?pdf=${PDFId}`,
                        );
                      }
                    }}
                    className={classNames(
                      styles.button,
                      inModal ? styles.modalButton : null,
                    )}
                  >
                    <NewIcon />
                  </div>
                </Tooltip>
              )}

              {/* Ikona „Dodaj do rejestru" także w trybie modalnym (np. podgląd
                  załącznika w PreviewModal) — tryb zwykły renderuje ją wyżej. */}
              {inModal && renderRegistryButton()}
            </>
          )}
          {showCloseButton && !onlyPDFButtons && (
            <>
              <div className={styles.spacer}></div>
              <Tooltip title={t("common.close")}>
                <div>
                  <CloseIcon
                    className={styles.closeButton}
                    onClick={handleClose}
                  />
                </div>
              </Tooltip>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PDFVieverHeader;
